module.exports = __webpack_public_path__ + "img/title_6.5de19a0f.png";